import Vue from "vue";
import VueRouter from "vue-router";
const Main = () => import("../views/main.vue");
const Test = () => import("../views/test.vue");
const Enterprise = () => import("../views/enterprise.vue");
const invoice = () => import("../views/invoice-yiqi/invoice.vue");
const Login = () => import("../views/login.vue");
const Threads = () => import("../views/thread/threads.vue");
const Index = () => import("../views/index.vue");

const MyThread = () => import("../views/thread/thread_mine.vue");
const AllThread = () => import("../views/thread/thread_all.vue");
const MyResources = () => import("../views/thread/my_resources.vue");
const ClientThread = () => import("../views/thread/thread_client.vue");
const PoolThread = () => import("../views/thread/thread_pool.vue");
const RecyleThread = () => import("../views/thread/thread_recyle.vue");
const SettingThread = () => import("../views/thread/thread_setting.vue");
const WeixinResources = () => import("../views/thread/weixin-resource.vue");
const ThreadShare = () => import("../views/thread/thread_share.vue"); // 共享商机
const ThreadVisit = () => import("../views/thread/thread_visit.vue"); // 出访记录
const ThreadAllocation = () => import("../views/thread/thread_allocation.vue"); // 线索分配
const ThreadAllocationStatistics = () =>
  import("../views/thread/thread_allocation_statistics.vue"); // 线索统计

const Department = () => import("../views/department.vue");
const Employee = () => import("../views/employee_setting.vue");
const Company = () => import("../views/company_setting.vue");
const DepartmentSetting = () => import("../views/department_setting.vue");

const System = () => import("../views/system/system.vue");
const SystemAuthority = () => import("../views/system_authority.vue");
const RoleSetting = () => import("../views/role_setting.vue");
const OrganizationSetting = () =>
  import("../views/system/organization_setting.vue");
const XcxSwiper = () => import("../views/system/xcx_swiper.vue");
const XcxPolicy = () => import("../views/system/xcx_policy.vue");
const XcxService = () => import("../views/system/xcx_service.vue");

const Person = () => import("../views/person.vue");
const PersonInfo = () => import("../views/person_info.vue");
const PersonICon = () => import("../views/person_icon.vue");

const Client = () => import("../views/client/client.vue");
const ClientInfo = () => import("../views/client/client_info.vue");
const ClientConnect = () => import("../views/client/client_connect.vue");
const ClientSetting = () => import("../views/client/client_setting.vue");
const ClientCheck = () => import("../views/client/client_check.vue");
const ClientReady = () => import("../views/client/client_ready.vue"); // 预流失客户
const ClientQualification = () =>
  import("../views/client/client_qualification.vue"); // 客户资质
const ClientBoss = () => import("../views/client/client_boss.vue"); // 老板资料

const Contract = () => import("../views/contract/contract.vue");
const ContractInfo = () => import("../views/contract/contract_info.vue");
const ContractCheck = () => import("../views/contract/contract_check.vue");
const ContractNote = () => import("../views/contract/contract_note.vue");
const ContractRenew = () => import("../views/contract/contract_renew.vue");
const ContractInvoice = () => import("../views/contract/contract_invoice.vue");
const ContractWork = () => import("../views/contract/contract_work.vue");
const ContractPayment = () => import("../views/contract/contract_payment.vue");
const ContractSetting = () => import("../views/contract/contract_setting.vue");
const ContractTicketSetting = () =>
  import("../views/contract/contract_ticket_setting.vue");
const ContractTicketGive = () =>
  import("../views/contract/contract_ticket_give.vue");
const ContractPaymentCheck = () =>
  import("../views/contract/contract_payment_check.vue");

const Product = () => import("../views/product/product.vue");
const ProductList = () => import("../views/product/product_list.vue");
const ServeItem = () => import("../views/product/serve_item.vue");

const Invoice = () => import("../views/invoice/invoice.vue");
const InvoiceRegister = () => import("../views/invoice/invoice_register.vue");
const InvoiceGather = () => import("../views/invoice/invoice_gather.vue");
const InvoiceInfo = () => import("../views/invoice/invoice_info.vue");
const InvoiceTotal = () => import("../views/invoice/invoice_total.vue");
const InvoiceAccount = () => import("../views/invoice/invoice_account.vue");
const InvoiceSetting = () => import("../views/invoice/invoice_setting.vue");
const InvoiceCheck = () => import("../views/invoice/invoice_check.vue");
const TheirTickets = () => import("../views/invoice/their_tickets.vue");
const CommoditySetting = () => import("../views/invoice/commodity_setting.vue");
const InvoiceKeywordSetting = () =>
  import("../views/invoice/invoice_keyword_setting.vue");
const InvoiceMessage = () => import("../views/invoice/invoice_message.vue");

const Waite = () => import("../views/waite/waite.vue");
const WaiteAll = () => import("../views/waite/waite_all.vue");
const WaiteThread = () => import("../views/waite/waite_thread.vue");
const WaiteContract = () => import("../views/waite/waite_contract.vue");
const WaiteClient = () => import("../views/waite/waite_client.vue");
const WaiteInvoice = () => import("../views/waite/waite_invoice.vue");

const DepartureSetting = () => import("../views/departure_setting.vue");

const Report = () => import("../views/report/report.vue");
const ReportCollection = () => import("../views/report/report_collection.vue");
const ReportSales = () => import("../views/report/report_sales.vue");
const ReportRenewal = () => import("../views/report/report_renewal.vue");
const ReportFollow = () => import("../views/report/report_follow.vue");
const ReportReimburse = () => import("../views/report/report_reimburse.vue");
const EmployeeInformation = () => import("../views/report/report.vue");
const CallList = () => import("../views/report/call_list.vue");
const CallDay = () => import("../views/report/call_day.vue");
const copyRecord = () => import("../views/report/copy_record.vue");
const FailList = () => import("../views/report/fail_list.vue");
const ReportInvoice = () => import("../views/report/report_invoice.vue");
const ReportFinancial = () => import("../views/report/report_financial.vue");
const ReportManage = () => import("../views/report/report_manage.vue");

const wechatClient = () => import("../views/wechat_client.vue");
const wechatLink = () => import("../views/wechat_link.vue");
const WechatAddContract = () => import("../components/wechat-add-contract.vue");

const Knowledge = () => import("../views/knowledge/knowledge.vue");
const KnowledgeBase = () => import("../views/knowledge/knowledge_base.vue");
const PublicNotice = () => import("../views/knowledge/public_notice.vue");
const KnowledgeSetting = () =>
  import("../views/knowledge/knowledge_setting.vue");
const KnowledgeCollege = () =>
  import("../views/knowledge/knowledge_college.vue");
const KnowledgeExamination = () =>
  import("../views/knowledge/knowledge_examination.vue");
const KnowledgePaper = () => import("../views/knowledge/knowledge_paper.vue");
const KnowledgeRecord = () => import("../views/knowledge/knowledge_record.vue");
const KnowledgeRecordAll = () =>
  import("../views/knowledge/knowledge_record_all.vue");
const KnowledgePlan = () => import("../views/knowledge/knowledge_plan.vue");
const KnowledgeEvaluation = () =>
  import("../views/knowledge/knowledge_evaluation.vue");
const KnowledgeStatement = () =>
  import("../views/knowledge/knowledge_statement.vue");
const KnowledgePackage = () =>
  import("../views/knowledge/knowledge_package.vue");

const WechatInvoiceInfo = () => import("../components/invoice-info.vue");

const Human = () => import("../views/human/human.vue");
const MyHuman = () => import("../views/human/human_mine.vue");
const HumanBase = () => import("../views/human/human_base.vue");
const HumanSetting = () => import("../views/human/human_setting.vue");
const HumanPayroll = () => import("../views/human/human_payroll.vue");
const HumanPayrollSetting = () =>
  import("../views/human/human_payroll_setting.vue");
const HumanNote = () => import("../views/human/human_note.vue");
const HumanPerformance = () => import("../views/human/human_performance.vue");
const HumanDispatch = () => import("../views/human/human_dispatch.vue");
const HumanContract = () => import("../views/human/human_contract.vue");
const humanResume = () => import("../views/human/human_resume.vue");
const humanEmployee = () => import("../views/human/human_employee.vue");
const humanGenjin = () => import("../views/human/human_genjin.vue");
const humanCard = () => import("../views/human/human_card.vue");
const humanSalary = () => import("../views/human/human_salary.vue");
const humanCheck = () => import("../views/human/human_check.vue");
const humanAssess = () => import("../views/human/human_assess.vue"); // 绩效考核
const humanEvaluate = () => import("../views/human/human_evaluate.vue"); // 考评信息
const humanRule = () => import("../views/human/human_rule.vue"); // 考评规则

const Reimbursement = () => import("../views/reimbursement/reimbursement.vue");
const MyReimbursement = () =>
  import("../views/reimbursement/my_reimbursement.vue");
const AllReimbursement = () =>
  import("../views/reimbursement/all_reimbursement.vue");
const CheckReimbursement = () =>
  import("../views/reimbursement/check_reimbursement.vue");
const ReimbursementSetting = () =>
  import("../views/reimbursement/reimbursement_setting.vue");

const ReDepartmentDetails = () =>
  import("../views/department/department_details.vue");

const Archives = () => import("../views/archives/archives.vue");
const ArchivesInfo = () => import("../views/archives/archives_info.vue");
const ArchivesSetting = () => import("../views/archives/archives_setting.vue");

const Expressage = () => import("../views/expressage/expressage.vue");
const ExpressageInfo = () => import("../views/expressage/expressage_info.vue");
const ExpressageMaintain = () =>
  import("../views/expressage/expressage_maintain.vue");
const ExpressageAccount = () =>
  import("../views/expressage/expressage_account.vue");
const ExpressageSetting = () =>
  import("../views/expressage/expressage_setting.vue");

const Dispatch = () => import("../views/dispatch/dispatch.vue");
const MyAssignment = () => import("../views/dispatch/myAssignment.vue");
const MyDispatch = () => import("../views/dispatch/myDispatch.vue");
const DispatchSetting = () => import("../views/dispatch/dispatch_setting.vue");
const DispatchPool = () => import("@/views/dispatch/dispatch_pool.vue");
const DispatchContract = () => import("@/views/dispatch/dispatch_contract.vue");
const DispatchSocial = () => import("@/views/dispatch/dispatch_social.vue");
const DispatchLang = () => import("@/views/dispatch/dispatch_lang.vue"); // 周期服务
const DispatchShort = () => import("@/views/dispatch/dispatch_short.vue"); // 短期交付
const DispatchInfo = () => import("@/views/dispatch/dispatch_info.vue"); // 合规服务
const DispatchInvoice = () => import("@/views/dispatch/dispatch_invoice.vue"); // 发票服务
const DispatchCheck = () => import("@/views/dispatch/dispatch_check.vue"); // 合规发票审核
const DispatchEvidence = () => import("@/views/dispatch/dispatch_evidence.vue"); // 证据链
const DispatchStatement = () =>
  import("@/views/dispatch/dispatch_statement.vue"); // 对报表
const DispatchCalculate = () =>
  import("@/views/dispatch/dispatch_calculate.vue"); // 预决算
const DispatchSchedule = () => import("@/views/dispatch/dispatch_schedule.vue"); // 日程表
const DispatchReport = () => import("@/views/dispatch/dispatch_report.vue"); // 约汇报
const BudgetExecution = () => import("@/views/dispatch/budget_execution.vue");

const Tax = () => import("@/views/tax/tax.vue");
const TaxInfo = () => import("@/views/tax/tax_info.vue");
const SocialSecurity = () => import("@/views/tax/social_security.vue");
const SocialCheck = () => import("@/views/tax/social_check.vue");
const TaxStatement = () => import("@/views/tax/tax_statement.vue"); // 企业流水
const TaxPark = () => import("@/views/tax/tax_park.vue"); // 企业园区
const TaxUnbilled = () => import("@/views/tax/tax_unbilled.vue"); // 未开票收入
const TaxCost = () => import("@/views/tax/tax_cost.vue"); // 财务数据

const Task = () => import("@/views/task/task.vue");
const TaskInfo = () => import("@/views/task/task-info.vue");
const TaskCalendar = () => import("@/views/task/task-calendar.vue");
const TaskSetting = () => import("@/views/task/task-setting.vue");

const DemandPublishPage = () =>
  import("@/views/thread/demand/demand-publish/page/index.vue");
const MyDemandPage = () =>
  import("@/views/thread/demand/my-demand/page/index.vue");
const MyTaskPage = () => import("@/views/thread/demand/my-task/page/index.vue");
const SharePaymentCode = () => import("@/views/contract/share/payment-code");

Vue.use(VueRouter);

let routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/main",
    name: "Main",
    component: Main,
    // redirect: "/main/index",
    children: [
      {
        path: "index", // 首页
        name: "Index",
        component: Index,
      },
      {
        path: "thread", // 商机
        name: "Threads",
        component: Threads,
        // redirect: "/main/thread/my-thread",
        children: [
          {
            path: "my-thread", // 我的商机
            name: "MyThread",
            component: MyThread,
          },
          {
            path: "all-thread", // 全部商机
            name: "AllThread",
            component: AllThread,
          },
          {
            path: "my-resources", // 我的资源
            name: "MyResources",
            component: MyResources,
          },
          {
            path: "weixin-resources", // 微信待加
            name: "WeixinResources",
            component: WeixinResources,
          },
          {
            path: "thread-share", // 共享商机
            name: "ThreadShare",
            component: ThreadShare,
          },
          {
            path: "thread-visit", // 出访记录
            name: "ThreadVisit",
            component: ThreadVisit,
          },
          {
            path: "thread-allocation", // 线索分配
            name: "threadAllocation",
            component: ThreadAllocation,
          },
          {
            path: "thread-allocation-statistics", // 线索统计
            name: "threadAllocationStatistics",
            component: ThreadAllocationStatistics,
          },
          {
            path: "client-thread", // 已签约客户
            name: "ClientThread",
            component: ClientThread,
          },
          {
            path: "threads", // 商机中的商机池
            name: "PoolThread",
            component: PoolThread,
          },
          {
            path: "threads-recyle", // 商机中的回收站
            name: "RecyleThread",
            component: RecyleThread,
          },
          {
            path: "thread-setting", // 商机中的设置
            name: "SettingThread",
            component: SettingThread,
          },
          {
            path: "demand-publish-page", // 需求发布
            name: "DemandPublishPage",
            component: DemandPublishPage,
          },
          {
            path: "my-demand-page", // 我的需求
            name: "MyDemandPage",
            component: MyDemandPage,
          },
          {
            path: "my-task-page", // 我的任务
            name: "MyTaskPage",
            component: MyTaskPage,
          },
        ],
      },
      {
        path: "client", // 客户
        name: "Client",
        component: Client,
        redirect: "/main/client/client-info",
        children: [
          {
            path: "client-info", // 客户资料
            name: "ClientInfo",
            component: ClientInfo,
          },
          {
            path: "client-qualification", // 客户资质
            name: "ClientQualification",
            component: ClientQualification,
          },
          {
            path: "client-boss", // 老板资料
            name: "ClientBoss",
            component: ClientBoss,
          },
          {
            path: "client-connect", // 工作交接
            name: "ClientConnect",
            component: ClientConnect,
          },
          {
            path: "client-check", // 流失审核
            name: "ClientCheck",
            component: ClientCheck,
          },
          {
            path: "client-ready", // 预流失客户
            name: "ClientReady",
            component: ClientReady,
          },
          {
            path: "client-recyle", // 回收站
            name: "ClientInfo",
            component: ClientInfo,
          },
          {
            path: "client-setting", // 设置
            name: "ClientSetting",
            component: ClientSetting,
          },
        ],
      },
      {
        path: "contract", // 合同
        name: "Contract",
        component: Contract,
        redirect: "/main/contract/contract-info",
        children: [
          {
            path: "contract-info", // 周期合同
            name: "ContractInfo",
            component: ContractInfo,
          },
          {
            path: "contract-check", // 合同审核
            name: "ContractCheck",
            component: ContractCheck,
          },
          {
            path: "contract-note", // 记单合同
            name: "ContractNote",
            component: ContractNote,
          },
          {
            path: "contract-payment", // 财务收款
            name: "ContractPayment",
            component: ContractPayment,
          },
          {
            path: "contract-work", // 合同派工
            name: "ContractWork",
            component: ContractWork,
          },
          {
            path: "contract-renew", // 续签管理
            name: "ContractRenew",
            component: ContractRenew,
          },
          {
            path: "contract-invoice", // 发票记录
            name: "ContractInvoice",
            component: ContractInvoice,
          },
          {
            path: "contract-setting", // 设置
            name: "ContractSetting",
            component: ContractSetting,
          },
          {
            path: "contract-ticket-setting", // 优惠券设置
            name: "ContractTicketSetting",
            component: ContractTicketSetting,
          },
          {
            path: "contract-ticket-give", // 优惠券发放
            name: "ContractTicketGive",
            component: ContractTicketGive,
          },
          {
            path: "contract-payment-check", // 退款审核
            name: "ContractPaymentCheck",
            component: ContractPaymentCheck,
          },
        ],
      },
      {
        path: "department", // 部门及用户设置
        name: "Department",
        component: Department,
        // redirect: "/main/department/department-setting",
        children: [
          {
            path: "department-setting", // 部门设置
            name: "DepartmentSetting",
            // component: DepartmentSetting,
            component: ReDepartmentDetails,
          },
          {
            path: "company-setting", // 机构设置
            name: "Company",
            component: Company,
          },
          {
            path: "employee-setting", // 用户设置
            name: "Employee",
            component: Employee,
          },
          {
            path: "departure-setting", // 员工离职设置
            name: "DepartureSetting",
            component: DepartureSetting,
          },
        ],
      },
      {
        path: "invoice", // 发票
        name: "Invoice",
        component: Invoice,
        redirect: "/main/invoice/invoice-info",
        children: [
          {
            path: "invoice-info", // 发票开具
            name: "InvoiceInfo",
            component: InvoiceInfo,
          },
          {
            path: "invoice-account", // 数电账号
            name: "InvoiceAccount",
            component: InvoiceAccount,
          },
          {
            path: "invoice-check", // 发票审核
            name: "InvoiceCheck",
            component: InvoiceCheck,
          },
          {
            path: "invoice-total", // 发票统计
            name: "InvoiceTotal",
            component: InvoiceTotal,
          },
          {
            path: "invoice-message", // 发票消息推送
            name: "InvoiceMessage",
            component: InvoiceMessage,
          },
          {
            path: "their-tickets", // 领票设置
            name: "TheirTickets",
            component: TheirTickets,
          },
          {
            path: "invoice-collect", // 发票汇总
            name: "InvoiceCollect",
            component: ServeItem,
          },
          {
            path: "invoice-register", // 理票登记
            name: "InvoiceRegister",
            component: InvoiceRegister,
          },
          {
            path: "invoice-gather", // 进销项采集
            name: "InvoiceGather",
            component: InvoiceGather,
          },
          {
            path: "invoice-setting", // 客户设置
            name: "InvoiceSetting",
            component: InvoiceSetting,
          },
          {
            path: "commodity-setting", // 常用商品设置
            name: "CommoditySetting",
            component: CommoditySetting,
          },
          {
            path: "invoice-keyword-setting", // 发票关键词设置
            name: "InvoiceKeywordSetting",
            component: InvoiceKeywordSetting,
          },
        ],
      },
      {
        path: "tax", // 税务
        name: "Tax",
        component: Tax,
        redirect: "/main/tax/tax-info",
        children: [
          {
            path: "tax-info", // 税务统计
            name: "TaxInfo",
            component: TaxInfo,
          },
          {
            path: "social-security", // 社保统计
            name: "SocialSecurity",
            component: SocialSecurity,
          },
          {
            path: "social-check", // 社保审核
            name: "SocialCheck",
            component: SocialCheck,
          },
          {
            path: "tax-statement", // 企业流水
            name: "TaxStatement",
            component: TaxStatement,
          },
          {
            path: "tax-park", // 企业园区
            name: "TaxPark",
            component: TaxPark,
          },
          {
            path: "tax-unbilled", // 未开票收入
            name: "TaxUnbilled",
            component: TaxUnbilled,
          },
          {
            path: "tax-cost", // 财务数据
            name: "TaxCost",
            component: TaxCost,
          },
        ],
      },
      {
        path: "task", // 日程
        name: "Task",
        component: Task,
        redirect: "/main/task/task-info",
        children: [
          {
            path: "task-info", // 日程列表
            name: "TaskInfo",
            component: TaskInfo,
          },
          {
            path: "task-calendar", // 日程总览
            name: "TaskCalendar",
            component: TaskCalendar,
          },
          {
            path: "task-setting", // 日程设置
            name: "TaskSetting",
            component: TaskSetting,
          },
        ],
      },
      {
        path: "system", // 系统设置
        name: "System",
        component: System,
        children: [
          {
            path: "authority-management", // 权限管理
            name: "RoleSetting",
            component: RoleSetting,
          },
          {
            path: "organization-setting", // 机构设置
            name: "OrganizationSetting",
            component: OrganizationSetting,
          },
          {
            path: "xcx-swiper", // 小程序 轮播图
            name: "XcxSwiper",
            component: XcxSwiper,
          },
          {
            path: "xcx-policy", // 小程序 最新政策
            name: "XcxPolicy",
            component: XcxPolicy,
          },
          {
            path: "xcx-service", // 小程序 更多服务
            name: "XcxService",
            component: XcxService,
          },
        ],
      },
      {
        path: "person", // 个人设置
        name: "Person",
        component: Person,
        redirect: "/main/person/person-info",
        children: [
          {
            path: "person-info", // 个人资料
            name: "PersonInfo",
            component: PersonInfo,
          },
          {
            path: "person-icon", // 头像设置
            name: "PersonICon",
            component: PersonICon,
          },
        ],
      },
      {
        path: "product", // 产品
        name: "Product",
        component: Product,
        redirect: "/main/product/product-list",
        children: [
          {
            path: "product-list", // 产品组合
            name: "ProductList",
            component: ProductList,
          },
          {
            path: "serve-item", // 服务项管理
            name: "ServeItem",
            component: ServeItem,
          },
        ],
      },
      // {
      //     path: "waite", // 待办
      //     name: "Waite",
      //     component: Waite,
      //     redirect: "/main/waite/waite-all",
      //     children: [{
      //         path: "waite-all", // 所有待办
      //         name: "WaiteAll",
      //         component: WaiteAll,
      //     }, {
      //         path: "waite-thread", // 待跟进商机
      //         name: "WaiteThread",
      //         component: WaiteThread,
      //     }, {
      //         path: "waite-contract", // 合同待办
      //         name: "WaiteContract",
      //         component: WaiteContract,
      //     }, {
      //         path: "waite-client", // 待客户流失审核
      //         name: "WaiteClient",
      //         component: WaiteClient,
      //     }, {
      //         path: "waite-invoice", // 待开票
      //         name: "WaiteInvoice",
      //         component: WaiteInvoice,
      //     }, ]
      // },
      {
        path: "dispatch", // 派工
        name: "dispatch",
        component: Dispatch,
        redirect: "/main/dispatch/my-assignment",
        children: [
          {
            path: "dispatch-info", // 合规户
            name: "DispatchInfo",
            component: DispatchInfo,
          },
          {
            path: "dispatch-invoice", // 合规发票
            name: "DispatchInvoice",
            component: DispatchInvoice,
          },
          {
            path: "dispatch-check", // 审发票
            name: "DispatchCheck",
            component: DispatchCheck,
          },
          {
            path: "dispatch-evidence", // 证据链
            name: "DispatchEvidence",
            component: DispatchEvidence,
          },
          {
            path: "dispatch-statement", // 对报表
            name: "DispatchStatement",
            component: DispatchStatement,
          },
          {
            path: "dispatch-calculate", // 预决算
            name: "DispatchCalculate",
            component: DispatchCalculate,
          },
          {
            path: "dispatch-schedule", // 日程表
            name: "DispatchSchedule",
            component: DispatchSchedule,
          },
          {
            path: "dispatch-report", // 约汇报
            name: "DispatchReport",
            component: DispatchReport,
          },
          {
            path: "dispatch-lang", // 周期服务
            name: "DispatchLang",
            component: DispatchLang,
          },
          {
            path: "dispatch-short", // 短期交付
            name: "DispatchShort",
            component: DispatchShort,
          },
          {
            path: "my-assignment", // 我的任务
            name: "myAssignment",
            component: MyAssignment,
          },
          {
            path: "my-dispatch", // 我的派工
            name: "myDispatch",
            component: MyDispatch,
          },
          {
            path: "dispatch-pool", // 派工池
            name: "dispatchPool",
            component: DispatchPool,
          },
          {
            path: "dispatch-contract", // 合同派工
            name: "dispatchContract",
            component: DispatchContract,
          },
          {
            path: "dispatch-social", // 合同派工
            name: "dispatchSocial",
            component: DispatchSocial,
          },
          {
            path: "dispatch-setting", // 设置
            name: "dispatchSetting",
            component: DispatchSetting,
          },
          {
            path: "budget-execution", // 预算执行情况表
            name: "BudgetExecution",
            component: BudgetExecution,
          },
        ],
      },
      {
        path: "report", // 报表
        name: "report",
        component: Report,
        redirect: "/main/report/report-collection",
        children: [
          {
            path: "report-collection", // 收款报表
            name: "ReportCollection",
            component: ReportCollection,
          },
          {
            path: "report-manage", // 经营报表
            name: "ReportManage",
            component: ReportManage,
          },
          {
            path: "report-sales", // 销售统计
            name: "ReportSales",
            component: ReportSales,
          },
          {
            path: "report-renewal", // 续费统计
            name: "ReportRenewal",
            component: ReportRenewal,
          },
          {
            path: "report-follow", // 跟进记录
            name: "ReportFollow",
            component: ReportFollow,
          },
          {
            path: "report-reimburse", // 报销报表
            name: "ReportReimburse",
            component: ReportReimburse,
          },
          {
            path: "employee-information", // 员工信息
            name: "EmployeeInformation",
            component: EmployeeInformation,
          },
          {
            path: "call-list", // 话单列表
            name: "CallList",
            component: CallList,
          },
          {
            path: "call-day", // 日账单
            name: "CallDay",
            component: CallDay,
          },
          {
            path: "copy-record", // 复制记录
            name: "copyRecord",
            component: copyRecord,
          },
          {
            path: "fail-list", // 失败列表
            name: "FailList",
            component: FailList,
          },
          {
            path: "report-invoice", // 发票报表
            name: "ReportInvoice",
            component: ReportInvoice,
          },
          {
            path: "report-financial", // 财务报表
            name: "ReportFinancial",
            component: ReportFinancial,
          },
        ],
      },
      {
        path: "knowledge", // 知识库
        name: "knowledge",
        component: Knowledge,
        redirect: "/main/knowledge/knowledge-base",
        children: [
          {
            path: "knowledge-base", // 知识
            name: "KnowledgeBase",
            component: KnowledgeBase,
          },
          {
            path: "knowledge-college", // 企学院
            name: "KnowledgeCollege",
            component: KnowledgeCollege,
          },
          {
            path: "knowledge-examination", // 考试题库
            name: "KnowledgeExamination",
            component: KnowledgeExamination,
          },
          {
            path: "knowledge-paper", // 考试试卷
            name: "KnowledgePaper",
            component: KnowledgePaper,
          },
          {
            path: "knowledge-record", // 考试记录
            name: "KnowledgeRecord",
            component: KnowledgeRecord,
          },
          {
            path: "knowledge-record-all", // 考试记录(全部)
            name: "KnowledgeRecordAll",
            component: KnowledgeRecordAll,
          },
          {
            path: "public-notice", // 公告
            name: "PublicNotice",
            component: PublicNotice,
          },
          {
            path: "knowledge-setting", // 知识库 -- 设置
            name: "KnowledgeSetting",
            component: KnowledgeSetting,
          },
          {
            path: "knowledge-plan", // 学习计划
            name: "KnowledgePlan",
            component: KnowledgePlan,
          },
          {
            path: "knowledge-evaluation", // 学习测评
            name: "KnowledgeEvaluation",
            component: KnowledgeEvaluation,
          },
        ],
      },
      {
        path: "archives", // 档案
        name: "archives",
        component: Archives,
        redirect: "/main/archives/archives-info",
        children: [
          {
            path: "archives-info", // 客户档案
            name: "archivesInfo",
            component: ArchivesInfo,
          },
          {
            path: "archives-setting", // 设置
            name: "ArchivesSetting",
            component: ArchivesSetting,
          },
        ],
      },
      {
        path: "expressage", // 快递
        name: "expressage",
        component: Expressage,
        redirect: "/main/expressage/expressage-info",
        children: [
          {
            path: "expressage-info", // 寄件管理
            name: "expressageInfo",
            component: ExpressageInfo,
          },
          {
            path: "expressage-maintain", // 地址维护
            name: "expressageMaintain",
            component: ExpressageMaintain,
          },
          {
            path: "expressage-account", // 我的账户
            name: "expressageAccount",
            component: ExpressageAccount,
          },
        ],
      },
      {
        path: "human", // 人力资源模块
        name: "human",
        component: Human,
        redirect: "/main/human/human-payroll",
        children: [
          {
            path: "human-payroll", // 工资单
            name: "HumanPayroll",
            component: HumanPayroll,
          },
          {
            path: "human-payroll-setting", // 工资单设置
            name: "HumanPayrollSetting",
            component: HumanPayrollSetting,
          },
          {
            path: "human-note", // 记单合同
            name: "HumanNote",
            component: HumanNote,
          },
          {
            path: "human-performance", // 业绩提成表
            name: "HumanPerformance",
            component: HumanPerformance,
          },
          {
            path: "human-dispatch", // 工商提成表
            name: "HumanDispatch",
            component: HumanDispatch,
          },
          {
            path: "human-contract", // 交付提成表
            name: "HumanContract",
            component: HumanContract,
          },
          {
            path: "human-resume", // 简历库
            name: "humanResume",
            component: humanResume,
          },
          {
            path: "human-genjin", // 人才跟进
            name: "humanGenjin",
            component: humanGenjin,
          },
          {
            path: "human-employee", // 员工信息
            name: "humanEmployee",
            component: humanEmployee,
          },
          {
            path: "human-card", // 卡牌测试
            name: "humanCard",
            component: humanCard,
          },
          {
            path: "human-salary", // 薪酬方案
            name: "humanSalary",
            component: humanSalary,
          },
          {
            path: "human-check", // 考勤记录
            name: "humanCheck",
            component: humanCheck,
          },
          {
            path: "human-assess", // 绩效考核
            name: "humanAssess",
            component: humanAssess,
          },
          {
            path: "human-evaluate", // 考评信息
            name: "humanEvaluate",
            component: humanEvaluate,
          },
          {
            path: "human-rule", // 考评规则
            name: "humanRule",
            component: humanRule,
          },
          {
            path: "human-mine", // 我的人才
            name: "MyHuman",
            component: MyHuman,
          },
          // {
          //     path: "human-base", // 人才库
          //     name: "HumanBase",
          //     component: HumanBase,
          // },
          {
            path: "human-setting", //  设置
            name: "HumanSetting",
            component: HumanSetting,
          },
          {
            path: "knowledge-statement", // 学习报表
            name: "KnowledgeStatement",
            component: KnowledgeStatement,
          },
          {
            path: "knowledge-package", // 学习计划包
            name: "KnowledgePackage",
            component: KnowledgePackage,
          },
        ],
      },
      {
        path: "reimbursement", // 报销模块
        name: "reimbursement",
        component: Reimbursement,
        redirect: "/main/reimbursement/my-reimbursement",
        children: [
          {
            path: "my-reimbursement", // 我的报销
            name: "MyReimbursement",
            component: MyReimbursement,
          },
          {
            path: "all-reimbursement", // 全部报销
            name: "AllReimbursement",
            component: AllReimbursement,
          },
          {
            path: "check-reimbursement", // 我的审批
            name: "CheckReimbursement",
            component: CheckReimbursement,
          },
          {
            path: "reimbursement-setting", // 报销设置
            name: "ReimbursementSetting",
            component: ReimbursementSetting,
          },
        ],
      },
    ],
  },
  {
    path: "/wechat-client",
    name: "wechatClient",
    component: wechatClient,
  },
  {
    path: "/wechat-link",
    name: "wechatLink",
    component: wechatLink,
  },
  {
    path: "/wechat-add-contract",
    name: "WechatAddContract",
    component: WechatAddContract,
  },
  {
    path: "/test",
    name: "Test",
    component: Test,
  },
  {
    path: "/enterprise",
    name: "Enterprise",
    component: Enterprise,
  },
  {
    path: "/invoice",
    name: "invoice",
    component: invoice,
  },
  {
    path: "/WechatInvoiceInfo",
    name: "WechatInvoiceInfo",
    component: WechatInvoiceInfo,
  },
  {
    path: "/share-payment-code",
    name: "SharePaymentCode",
    component: SharePaymentCode,
  },
];

let router = new VueRouter({
  routes,
});

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (
    to.path === "/" ||
    to.path === "/test" ||
    to.path === "/wechat-client" ||
    to.path === "/wechat-link" ||
    to.path === "/share-payment-code"
  ) {
    next();
  } else {
    // let token = sessionStorage.getItem('token');
    let baseInfo = sessionStorage.getItem("userData");
    // console.log("导航守卫", baseInfo);

    // if (token === 'null' || token === '') {
    if (baseInfo === "null" || baseInfo === "" || baseInfo == null) {
      next("/");
    } else {
      next();
    }
  }
});
//重复路由
let originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
